const binding = { modules: {}, dataActions: {} };

    (binding.modules['ecomm-job-details'] = {
        c: () => require('partner/modules/ecomm-job-details/ecomm-job-details.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ecomm-job-details',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ecomm-job-details'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ecomm-job-details|ecomm-job-details'] = {
                c: () => require('partner/modules/ecomm-job-details/ecomm-job-details.view.tsx'),
                cn: '__local__-__local__-ecomm-job-details'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };